/**
 * TabNav Component - 9-tab navigation with keyboard shortcut indicators
 */

import type { TabId, Tab } from '../../types'
import { TABS } from '../../types'

interface TabNavProps {
  activeTab: TabId
  onTabChange: (tabId: TabId) => void
}

export function TabNav({ activeTab, onTabChange }: TabNavProps) {
  return (
    <nav className="flex border-b border-term-border bg-term-bg px-2 overflow-x-auto">
      {TABS.map((tab: Tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`term-tab whitespace-nowrap flex items-center gap-1.5 ${
            activeTab === tab.id ? 'term-tab-active' : ''
          }`}
        >
          <span className="text-term-textDim text-xs font-mono">[{tab.shortcut}]</span>
          <span className="text-term-textDim text-xs font-mono mr-0.5">{tab.icon}</span>
          {tab.label}
        </button>
      ))}
    </nav>
  )
}
